import { axiosAPIInstance as axios } from '../../axios-config';

const actions = {
  async createUser(_, user) {
    const response = await axios.post('/blade/users', user);
    return response.data.user;
  },
  async uploadClassRoster(_, { classId, csvString }) {
    const response = await axios.post(`/users/classroster/${classId}`, { csvString });
    if (response.data.errors && response.data.errors.length && response.data.errors.length > 0) {
      if (response.data.errors.length === 1 && response.data.errors[0].email === 'Warning') {
        const err = response.data.errors[0];
        // eslint-disable-next-line no-alert
        alert(`${err.email}: ${err.message}`);
      } else {
        let alertStr = 'Failed to upload the following users...';
        for (let i = 0; i < response.data.errors.length; ++i) {
          const err = response.data.errors[i];
          alertStr += `\n${err.email}: ${err.message}`;
        }
        // eslint-disable-next-line no-alert
        alert(alertStr);
      }
    }
    return response.data.csvString;
  },
  async getUsers() {
    const response = await axios.get('/blade/users');
    return response.data.users;
  },
  async getClassUsers(_, { classId }) {
    const response = await axios.get(`/blade/classusers/${classId}`);
    return response.data.users;
  },
  async getGameUsers(_, { gameId }) {
    const response = await axios.get(`/blade/gameusers/${gameId}`);
    return response.data.users;
  },
  async getUser(_, { userId }) {
    const { data } = await axios.get(`/blade/users/${userId}`);
    return data;
  },
  async getUserTypes({ dispatch }) {
    return dispatch('getUser', { userId: 'types' });
  },
  async updateUser(_, user) {
    const response = await axios.patch(`/blade/users/${user._id}`, user);
    return response.data.user;
  },
  async updateUserPassword(_, { userId, password }) {
    const response = await axios.patch(`/blade/users/${userId}/password`, { password });
    return response.data.user;
  },
  async updateMe({ commit }, user) {
    const response = await axios.patch('/user', user);
    commit('setMe', { me: response.data.user });
    return response.data.user;
  },
  async updateMyPassword(_, { password }) {
    const response = await axios.patch('/user/password', { password });
    return response.data.user;
  },
  async helpClickTracker() {
    const response = await axios.patch('/user/helpclick', {});
    return response.data.user;
  },
  async deleteUser(_, { userId, _id }) {
    const did = userId || _id;
    const response = await axios.delete(`/blade/users/${did}`);
    return response.data.user;
  },
  // |‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾|
  // |                                USER REPORT GENERATION STUFF                                |
  // |____________________________________________________________________________________________|
  // TODO: we should really move all report endpoints into a dedicated file.
  // I don't want to unnecessarily move anything right now though.
  async getUsageDataConfigs() {
    const response = await axios.get('/blade/usageData/configs');
    return response.data.configs;
  },
  async getReasonDataConfigs() {
    const response = await axios.get('/blade/reasonData/configs');
    return response.data.configs;
  },
  async getUsageDataConfig(_, { configName }) {
    const { data } = await axios.get('/blade/usageData/config', {
      params: {
        name: configName
      }
    });
    return data.config;
  },
  async getReasonDataConfig(_, { configName }) {
    const { data } = await axios.get('/blade/reasonData/config', {
      params: {
        name: configName
      }
    });
    return data.config;
  },
  async createUsageDataConfig(_, config) {
    const response = await axios.post('/blade/usageData/config', config).catch((err) => {
      if (err.response) {
        console.log(err.response);
        // eslint-disable-next-line no-alert
        alert(err.response.data);
      }
    });
    return response.data.config;
  },
  async createReasonDataConfig(_, config) {
    const response = await axios.post('/blade/reasonData/config', config).catch((err) => {
      if (err.response) {
        console.log(err.response);
        // eslint-disable-next-line no-alert
        alert(err.response.data);
      }
    });
    return response.data.config;
  },
  async deleteUsageDataConfig(_, { configName }) {
    await axios.delete('/blade/usageData/config', {
      params: {
        name: configName
      }
    }).catch((err) => {
      if (err.response) {
        console.log(err.response);
        // eslint-disable-next-line no-alert
        alert(err.response.data);
      }
    });
  },
  async deleteReasonDataConfig(_, { configName }) {
    await axios.delete('/blade/reasonData/config', {
      params: {
        name: configName
      }
    }).catch((err) => {
      if (err.response) {
        console.log(err.response);
        // eslint-disable-next-line no-alert
        alert(err.response.data);
      }
    });
  },
  /** returns JSON */
  async getUsageData({ dispatch }, options) {
    const response = await dispatch('checkForData', {
      endpoint: '/blade/usageData',
      params: {
        includeEmail: options.includeEmail,
        includeName: options.includeName,
        includeStudentId: options.includeStudentId,
        includeActivity: options.includeActivity,
        includeIndividualDecisionProgress: options.includeIndividualDecisionProgress,
        includeTeamDecisionProgress: options.includeTeamDecisionProgress,
        includeLastSignedInTimestamp: options.includeLastSignedInTimestamp,
        includeLastActiveTimestamp: options.includeLastActiveTimestamp,
        includeLastQuestionAnsweredTimestamp: options.includeLastQuestionAnsweredTimestamp,
        includeCompletedTimestamp: options.includeCompletedTimestamp,
        includeCash: options.includeCash,
        metricsToInclude: options.metricsToInclude,
        referencesToInclude: options.referencesToInclude,
        gamesToInclude: options.gamesToInclude,
        includeHelpClicks: options.includeHelpClicks,
        timeZone: options.timeZone,
        locale: options.locale,
        classesToInclude: options.classesToInclude,
        includeAllUsers: options.includeAllUsers,
        includeAllGameMetrics: options.includeAllGameMetrics,
        includeDuration: options.includeDuration,
        perChallengeTeamMetrics: options.perChallengeTeamMetrics,
        includePercentIndividualMetrics: options.includePercentIndividualMetrics,
        requireClass: options.requireClass,
      }
    });
    return response.data.data;
  },
  /** returns JSON */
  async getReasonData({ dispatch }, options) {
    const response = await dispatch('checkForData', {
      endpoint: '/blade/reasonData',
      params: {
        includeEmail: options.includeEmail,
        includeName: options.includeName,
        gamesToInclude: options.gamesToInclude,
        classesToInclude: options.classesToInclude,
        includeAllUsers: options.includeAllUsers,
        onlyFeedback: options.onlyFeedback,
        includeCompletedGame: options.includeCompletedGame,
        excludeFeedback: options.excludeFeedback,
        includeDuration: options.includeDuration,
        oneRowPerGameUser: options.oneRowPerGameUser,
        useReportTitlePrefix: options.useReportTitlePrefix,
        includeChangedMetrics: options.includeChangedMetrics,
        useMetricDeltas: options.useMetricDeltas,
        excludeReason: options.excludeReason,
        demographicMetrics: options.demographicMetrics,
        metricsToInclude: options.metricsToInclude,
        requireClass: options.requireClass,
      }
    });
    return response.data.data;
  },
  /** returns CSV string (deprecated) */
  async getReasonDataCSV({ dispatch }, options) {
    const response = await dispatch('checkForData', {
      endpoint: '/blade/reasonDataCSV',
      params: {
        includeEmail: options.includeEmail,
        includeName: options.includeName,
        gamesToInclude: options.gamesToInclude,
        classesToInclude: options.classesToInclude,
        includeAllUsers: options.includeAllUsers
      }
    });
    return response.data.data;
  },
  // reusable pattern for data generation functions
  // allows generation to take as long as desired
  // TODO: move this into a less specific Vuex module when/if it makes sense
  async checkForData({ dispatch }, { endpoint, params }) {
    // eslint-disable-next-line eqeqeq
    if (params.emptyCache == undefined) {
      params.emptyCache = false; // default to use the cached value
    }
    let response = await axios.get(endpoint, {
      params
    });
    if (!(response.data.data)) {
      params.checkComputing = true;
      await new Promise(r => setTimeout(r, 500)); // check for data every half second
      response = await dispatch('checkForData', { endpoint, params });
    }
    return response;
  }
};

export default {
  actions
};



// WEBPACK FOOTER //
// ./src/store/blade/users.js